export const RecaptchaSiteKey = window._env_.RECAPTCHA_SITE_KEY;